/**
 * @generated SignedSource<<61b5e6424dd8014ac0e0873e6e556315>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MetaAdCallToAction = "CONTACT_US" | "GET_QUOTE" | "LEARN_MORE" | "SHOP_NOW" | "SIGN_UP" | "SUBSCRIBE" | "%future added value";
export type UpdateMetaAdRequest = {
  approved?: boolean | null;
  callToAction?: MetaAdCallToAction | null;
  description?: string | null;
  destinationUrl?: string | null;
  displayUrl?: string | null;
  dominantColor?: string | null;
  facebookPageId?: string | null;
  headline?: string | null;
  id: string;
  instagramAccountId?: string | null;
  metaAdSetIds?: ReadonlyArray<string> | null;
  name?: string | null;
  primaryText?: string | null;
  tags?: ReadonlyArray<string> | null;
};
export type MetaAdsFilter = {
  approved?: boolean | null;
  count?: number | null;
  created?: boolean | null;
  cursor?: string | null;
  submittedForApproval?: boolean | null;
};
export type MetaAdApproveMutation$variables = {
  input: UpdateMetaAdRequest;
  metaAdsFilter?: MetaAdsFilter | null;
};
export type MetaAdApproveMutation$data = {
  readonly updateMetaAd: {
    readonly approved: boolean;
    readonly brand: {
      readonly approvedMetaAdCount: number;
      readonly id: string;
      readonly invalidDraftMetaAdCount: number;
      readonly unapprovedMetaAdCount: number;
      readonly " $fragmentSpreads": FragmentRefs<"CreativeList">;
    };
    readonly id: string;
  };
};
export type MetaAdApproveMutation = {
  response: MetaAdApproveMutation$data;
  variables: MetaAdApproveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "metaAdsFilter"
  }
],
v1 = {
  "kind": "Variable",
  "name": "metaAdsFilter",
  "variableName": "metaAdsFilter"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  },
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approved",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvedMetaAdCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unapprovedMetaAdCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invalidDraftMetaAdCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v10 = [
  (v8/*: any*/),
  (v9/*: any*/),
  (v3/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MetaAdApproveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "MetaAd",
        "kind": "LinkedField",
        "name": "updateMetaAd",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Brand",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CreativeList"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MetaAdApproveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "MetaAd",
        "kind": "LinkedField",
        "name": "updateMetaAd",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Brand",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": [
                  (v1/*: any*/)
                ],
                "concreteType": "MetaAd",
                "kind": "LinkedField",
                "name": "metaAds",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "callToAction",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "destinationUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "headline",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryText",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "facebookPageId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "instagramAccountId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacebookPage",
                    "kind": "LinkedField",
                    "name": "facebookPage",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InstagramAccount",
                    "kind": "LinkedField",
                    "name": "instagramAccount",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MetaAdMetaAdSet",
                    "kind": "LinkedField",
                    "name": "metaAdMetaAdSets",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MetaAdSet",
                        "kind": "LinkedField",
                        "name": "metaAdSet",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "campaignName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MetaAdAccount",
                            "kind": "LinkedField",
                            "name": "metaAdAccount",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveStatus",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VisualAsset",
                    "kind": "LinkedField",
                    "name": "visualAssets",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "created",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "submittedForApproval",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fullName",
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Insight",
                    "kind": "LinkedField",
                    "name": "insights",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isMet",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Brand",
                    "kind": "LinkedField",
                    "name": "brand",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6165d83794259ac6437bd3220db3298a",
    "id": null,
    "metadata": {},
    "name": "MetaAdApproveMutation",
    "operationKind": "mutation",
    "text": "mutation MetaAdApproveMutation(\n  $input: UpdateMetaAdRequest!\n  $metaAdsFilter: MetaAdsFilter\n) {\n  updateMetaAd(input: $input, metaAdsFilter: $metaAdsFilter) {\n    id\n    approved\n    brand {\n      id\n      approvedMetaAdCount\n      unapprovedMetaAdCount\n      invalidDraftMetaAdCount\n      ...CreativeList\n    }\n  }\n}\n\nfragment Comment on Comment {\n  id\n  createdAt\n  text\n  user {\n    id\n    fullName\n    picture\n  }\n}\n\nfragment CommentList on MetaAd {\n  comments {\n    id\n    ...Comment\n  }\n}\n\nfragment CreativeAdvisorInsight on Insight {\n  text\n  isMet\n}\n\nfragment CreativeAdvisorMetaAd on MetaAd {\n  insights {\n    id\n    text\n    ...CreativeAdvisorInsight\n  }\n}\n\nfragment CreativeDrawerMetaAd on MetaAd {\n  id\n  approved\n  created\n  submittedForApproval\n  comments {\n    id\n  }\n  visualAssets {\n    id\n  }\n  ...CreativeAdvisorMetaAd\n  ...CreativeTextForm\n  ...CommentList\n  ...MetaAdPreview\n}\n\nfragment CreativeList on Brand {\n  metaAds(metaAdsFilter: $metaAdsFilter) {\n    id\n    ...MetaAd\n  }\n}\n\nfragment CreativeTextForm on MetaAd {\n  id\n  callToAction\n  name\n  description\n  destinationUrl\n  displayUrl\n  headline\n  primaryText\n  facebookPage {\n    id\n    name\n    picture\n  }\n  instagramAccount {\n    id\n    name\n    picture\n  }\n  metaAdMetaAdSets {\n    metaAdSet {\n      id\n      name\n      campaignName\n      metaAdAccount {\n        id\n        name\n      }\n      effectiveStatus\n      status\n    }\n  }\n}\n\nfragment MetaAd on MetaAd {\n  ...MetaAdPreview\n  ...CreativeDrawerMetaAd\n  id\n  approved\n  submittedForApproval\n  created\n  name\n  callToAction\n  description\n  destinationUrl\n  displayUrl\n  headline\n  primaryText\n  facebookPageId\n  instagramAccountId\n  brand {\n    id\n  }\n  comments {\n    id\n  }\n  visualAssets {\n    id\n  }\n}\n\nfragment MetaAdPreview on MetaAd {\n  id\n  callToAction\n  description\n  destinationUrl\n  displayUrl\n  headline\n  primaryText\n  facebookPageId\n  instagramAccountId\n  facebookPage {\n    name\n    picture\n  }\n  instagramAccount {\n    name\n    picture\n  }\n  metaAdMetaAdSets {\n    id\n  }\n  visualAssets {\n    type\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d06cc5775d0c908d4ed449b53215d50";

export default node;
